import dayjs from 'dayjs';

import type { InvoiceAndSaleFigureType } from '@/features/organization/types';

import {
  SHOP_ADDITIONAL_INFO_8,
  SHOP_ADDITIONAL_INFO_FROM_9_TO_13,
} from '../constants';

export enum ShopRegistrationStatusEnum {
  'pending-approval' = 'pending-approval',
  returned = 'returned',
  withdraw = 'temporary',
  official = 'official',
}

export enum ShopContractStatusEnum {
  'in-use' = 'in-use',
  suspended = 'suspended',
}

export enum ShopContractTypeEnum {
  normal = 'normal',
  event = 'event',
}

export interface ShopsResponse {
  total_records: number;
  shops: ShopResponseItem[];
}

export interface ShopResponseItem extends ShopRequest {
  id: number;
  organization_id: number;
  is_wedding_store: boolean;
  registration_status: ShopRegistrationStatusEnum;
  contract_status: ShopContractStatusEnum;
  login_app_qr: string;
  organization_name: string;
  normal_mode_qr: string;
  snap_drink_url: string;
  snap_drink_qr_image_url: string;
  is_use_wedding_store: boolean;
  fcode: string;
  expected_monthly_sales: string;
  phone_number: string;
  comment: string;
  submitter: string;
  submitted_at: string;
  is_printer_and_fixture_ordered: boolean;
  invoice_type: InvoiceAndSaleFigureType;
  has_ordered: boolean;
}

export interface ShopFiltersFormValues {
  name: string;
  registration_status?: ShopRegistrationStatusEnum[];
  contract_type_status?: ShopContractTypeEnum[];
}

export interface ShopApprovalFiltersFormValues {
  contract_status?: ShopContractStatusEnum[];
  registration_status?: ShopRegistrationStatusEnum[];
}

export interface ShopApprovalRequestsResponse {
  total_records: number;
  temporary_shops: ShopResponseItem[];
}

export type ShopShippingInformation = Record<
  (typeof SHOP_ADDITIONAL_INFO_FROM_9_TO_13)[number]['id'],
  (typeof SHOP_ADDITIONAL_INFO_FROM_9_TO_13)[number]['value']
>;

export interface ShopRequest {
  name: string;
  contract_type: ShopContractTypeEnum;
  contact_name: string;
  company_name: string;
  address: string;
  email_address: string;
  zipcode: string;
  invoice_registration?: string;
  is_store_registration_approved?: boolean;
  operation_start_date: dayjs.Dayjs;
  operation_end_date: dayjs.Dayjs;
  shipping_information?: ShopShippingInformation;
  options?: ShopShippingInformation[];
  invoice_type?: InvoiceAndSaleFigureType;
}

export interface ShopFormValues extends ShopRequest {
  additional_info_9_to_13: typeof SHOP_ADDITIONAL_INFO_FROM_9_TO_13;
  additional_info_8: typeof SHOP_ADDITIONAL_INFO_8;
}

export interface ShopWeddingRequest {
  name: string;
  account_name: string;
  account_email: string;
  operation_start_date: dayjs.Dayjs;
  operation_end_date: dayjs.Dayjs;
}

export interface ShopWeddingResponseItem extends ShopWeddingRequest {
  login_app_qr: string;
  organization_id: number;
  organization_name: string;
  normal_mode_qr: string;
  snap_drink_url: string;
  snap_drink_qr_image_url: string;
  contract_status: ShopContractStatusEnum;
}

export interface ShopRejectionRequest {
  comment?: string;
}
